export function getQueryParam(searchString: string, key: string): string | undefined {
	const query = searchString.substring(1);
	const vars = query.split("&");
	for (const entry of vars) {
		const pair = entry.split("=");
		// eslint-disable-next-line eqeqeq
		if (decodeURIComponent(pair[0]) == key) {
			return decodeURIComponent(pair[1]);
		}
	}
	return undefined;
}
